import { Box, Grid, Hidden, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const PREFIX = 'ServicesResume';

const classes = {
  textBox: `${PREFIX}-textBox`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${classes.textBox}`]: {
    marginLeft: theme.spacing(1),
    [theme.breakpoints.up('lg')]: {
      marginLeft: theme.spacing(0),
    },
  },
}));

const ServicesResume = ({ services }) => {
  const { t } = useTranslation('workOrdersTable');

  const [serviceName, setServiceName] = useState(null);

  useEffect(() => {
    const getServiceName = serviceList => {
      if (!serviceList?.length || serviceList?.length === 1)
        return serviceList[0]?.name || '';

      return `${serviceList[0].name}, ${serviceList.length - 1}+`;
    };

    setServiceName(getServiceName(services));
  }, [services, setServiceName]);

  return (
    <StyledBox>
      <Grid container>
        <Hidden lgUp>
          <Grid item>
            <Box>
              <Typography variant="subtitle2">
                {t('card.visibleContent.services')}
              </Typography>
            </Box>
          </Grid>
        </Hidden>
        <Grid item>
          <Box className={classes.textBox}>
            <Typography variant="body2" color="textSecondary">
              {serviceName}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </StyledBox>
  );
};

export default ServicesResume;
